// Auto Generated file, do not modify

export const AccountType = {
    "SalesLedger": "SalesLedger",
    "PurchaseLedger": "PurchaseLedger",
} as const;

export type AccountType = keyof typeof AccountType;

export const AgreementStabilityOption = {
    "None": "None",
    "Option1": "Option1",
    "Option2": "Option2",
    "Option3": "Option3",
    "Option4": "Option4",
} as const;

export type AgreementStabilityOption = keyof typeof AgreementStabilityOption;

export const AgreementsSearchType = {
    "All": "All",
    "Agreements": "Agreements",
    "Schedules": "Schedules",
    "Sheets": "Sheets",
} as const;

export type AgreementsSearchType = keyof typeof AgreementsSearchType;

export const AuthorisedSignatoryState = {
    "Submitted": "Submitted",
    "Authorised": "Authorised",
    "Rejected": "Rejected",
    "Archived": "Archived",
} as const;

export type AuthorisedSignatoryState = keyof typeof AuthorisedSignatoryState;

export const AuthorisedSignatoryStatus = {
    "ListedDirector": "ListedDirector",
    "Loa": "Loa",
} as const;

export type AuthorisedSignatoryStatus = keyof typeof AuthorisedSignatoryStatus;

export const BoilerPlateTandCsStatus = {
    "Draft": "Draft",
    "Live": "Live",
    "Inactive": "Inactive",
} as const;

export type BoilerPlateTandCsStatus = keyof typeof BoilerPlateTandCsStatus;

export const ClientInfoReviewState = {
    "Pending": "Pending",
    "Rejected": "Rejected",
    "Approved": "Approved",
} as const;

export type ClientInfoReviewState = keyof typeof ClientInfoReviewState;

export const ClientStatus = {
    "Prospective": "Prospective",
    "Live": "Live",
    "Dead": "Dead",
} as const;

export type ClientStatus = keyof typeof ClientStatus;

export const ContractType = {
    "None": "None",
    "PaperContract": "PaperContract",
    "HostingContract": "HostingContract",
} as const;

export type ContractType = keyof typeof ContractType;

export const DataCategory = {
    "NormalData": "NormalData",
    "SystemSeedData": "SystemSeedData",
    "DemoSeedData": "DemoSeedData",
    "DevSeedData": "DevSeedData",
    "TemporaryData": "TemporaryData",
} as const;

export type DataCategory = keyof typeof DataCategory;

export const DealerOfficeStatus = {
    "Prospective": "Prospective",
    "Live": "Live",
    "Dead": "Dead",
} as const;

export type DealerOfficeStatus = keyof typeof DealerOfficeStatus;

export const DealerStatus = {
    "Live": "Live",
    "Inactive": "Inactive",
} as const;

export type DealerStatus = keyof typeof DealerStatus;

export const DealerStructureLevel = {
    "LegalEntity": "LegalEntity",
    "Territory": "Territory",
    "Office": "Office",
} as const;

export type DealerStructureLevel = keyof typeof DealerStructureLevel;

export const DealerStructureRole = {
    "None": "None",
    "HeadOffice": "HeadOffice",
    "Finance": "Finance",
    "SettingsAndRates": "SettingsAndRates",
} as const;

export type DealerStructureRole = keyof typeof DealerStructureRole;

export const DirectDebitSignatory = {
    "NotRequired": "NotRequired",
    "SameAsAuthorisedSignatory": "SameAsAuthorisedSignatory",
    "NewSignatory": "NewSignatory",
} as const;

export type DirectDebitSignatory = keyof typeof DirectDebitSignatory;

export const DisableMinLogicAvailableOptions = {
    "None": "None",
    "QuarterlyServices": "QuarterlyServices",
    "SystemSchedule": "SystemSchedule",
} as const;

export type DisableMinLogicAvailableOptions =
    keyof typeof DisableMinLogicAvailableOptions;

export const DocumentFeeType = {
    "DocumentFee": "DocumentFee",
    "AnnualFee": "AnnualFee",
    "ArrearsAdminFee": "ArrearsAdminFee",
    "CustomerDetailsChangeFee": "CustomerDetailsChangeFee",
    "AdminFee": "AdminFee",
    "InvoiceAdminFee": "InvoiceAdminFee",
    "ArrearsAdminFee2": "ArrearsAdminFee2",
    "TerminationAdminFee": "TerminationAdminFee",
    "RewriteChargeStd": "RewriteChargeStd",
    "RewriteCharge15": "RewriteCharge15",
    "FranchiseFee": "FranchiseFee",
    "InvoiceCollectionFee": "InvoiceCollectionFee",
    "FailedDirectDebit": "FailedDirectDebit",
    "NovationFee": "NovationFee",
    "ReconciliationFee": "ReconciliationFee",
    "Title": "Title",
    "Other1": "Other1",
    "Other2": "Other2",
} as const;

export type DocumentFeeType = keyof typeof DocumentFeeType;

export const DocumentRecipientType = {
    "None": "None",
    "AuthorisedSignatory": "AuthorisedSignatory",
    "DirectDebitSignatory": "DirectDebitSignatory",
    "DocumentViewer": "DocumentViewer",
    "CopyDocument": "CopyDocument",
} as const;

export type DocumentRecipientType = keyof typeof DocumentRecipientType;

export const DocusignRecipientType = {
    "None": "None",
    "SupplierCheck": "SupplierCheck",
    "SupplierSignatory": "SupplierSignatory",
    "IpsCheck": "IpsCheck",
    "IpsSignatory": "IpsSignatory",
} as const;

export type DocusignRecipientType = keyof typeof DocusignRecipientType;

export const FieldType = {
    "Standard": "Standard",
    "Admin": "Admin",
    "IP": "IP",
} as const;

export type FieldType = keyof typeof FieldType;

export const FinanceType = {
    "None": "None",
    "EFA": "EFA",
    "FMV": "FMV",
} as const;

export type FinanceType = keyof typeof FinanceType;

export const FmvType = {
    "None": "None",
    "FullFmvValue": "FullFmvValue",
    "OfRrpValue": "OfRrpValue",
    "OfTotalCapitalOnly": "OfTotalCapitalOnly",
} as const;

export type FmvType = keyof typeof FmvType;

export const FunderAvailability = {
    "IPSOnly": "IPSOnly",
    "IPSSupplierAdmin": "IPSSupplierAdmin",
    "All": "All",
} as const;

export type FunderAvailability = keyof typeof FunderAvailability;

export const FunderStatus = {
    "Pending": "Pending",
    "Live": "Live",
    "NoNewDeals": "NoNewDeals",
    "Dead": "Dead",
} as const;

export type FunderStatus = keyof typeof FunderStatus;

export const FunderType = {
    "None": "None",
    "Funder": "Funder",
    "CoFunded": "CoFunded",
    "DealerFunded": "DealerFunded",
} as const;

export type FunderType = keyof typeof FunderType;

export const IpsProductScheduleStatus = {
    "NewProducts": "NewProducts",
    "NotNew": "NotNew",
    "SupplierOwned": "SupplierOwned",
    "AnotherPartner": "AnotherPartner",
    "RetainedProducts": "RetainedProducts",
    "CustomerOwned": "CustomerOwned",
} as const;

export type IpsProductScheduleStatus = keyof typeof IpsProductScheduleStatus;

export const LargeFormatItemType = {
    "None": "None",
    "Printer": "Printer",
    "Scanner": "Scanner",
    "Other": "Other",
    "Paper": "Paper",
} as const;

export type LargeFormatItemType = keyof typeof LargeFormatItemType;

export const LargeFormatMeterType = {
    "Ink": "Ink",
    "Cleaning": "Cleaning",
    "Scan": "Scan",
    "Paper": "Paper",
} as const;

export type LargeFormatMeterType = keyof typeof LargeFormatMeterType;

export const LargeFormatPriceType = {
    "None": "None",
    "PriceA": "PriceA",
    "PriceB": "PriceB",
} as const;

export type LargeFormatPriceType = keyof typeof LargeFormatPriceType;

export const NotificationLevel = {
    "Info": "Info",
    "Warning": "Warning",
    "Critical": "Critical",
} as const;

export type NotificationLevel = keyof typeof NotificationLevel;

export const NotificationReason = {
    "DocusignFailed": "DocusignFailed",
    "UncrystallisationFailed": "UncrystallisationFailed",
    "PreApprovalDeclined": "PreApprovalDeclined",
    "ApprovalDeclined": "ApprovalDeclined",
    "AutoResponded": "AutoResponded",
} as const;

export type NotificationReason = keyof typeof NotificationReason;

export const NotificationSource = {
    "Validation": "Validation",
    "DocuSign": "DocuSign",
    "PreApproval": "PreApproval",
    "Approval": "Approval",
} as const;

export type NotificationSource = keyof typeof NotificationSource;

export const PaperInclusiveChargeType = {
    "A4": "A4",
    "A4A3": "A4A3",
} as const;

export type PaperInclusiveChargeType = keyof typeof PaperInclusiveChargeType;

export const PaperSize = {
    "None": "None",
    "A4": "A4",
    "A3": "A3",
} as const;

export type PaperSize = keyof typeof PaperSize;

export const PaymentMethod = {
    "None": "None",
    "QuarterlyDirectDebit": "QuarterlyDirectDebit",
    "MonthlyInvoice": "MonthlyInvoice",
} as const;

export type PaymentMethod = keyof typeof PaymentMethod;

export const PrincipalProductScheduleStatus = {
    "NewProducts": "NewProducts",
    "NotNew": "NotNew",
    "PrincipalOwned": "PrincipalOwned",
    "AnotherPartner": "AnotherPartner",
    "RetainedProducts": "RetainedProducts",
    "CustomerOwned": "CustomerOwned",
} as const;

export type PrincipalProductScheduleStatus =
    keyof typeof PrincipalProductScheduleStatus;

export const ProductScheduleType = {
    "System": "System",
    "Software": "Software",
    "Accessory": "Accessory",
} as const;

export type ProductScheduleType = keyof typeof ProductScheduleType;

export const RateGroupStatus = {
    "Inactive": "Inactive",
    "Upcoming": "Upcoming",
    "Active": "Active",
    "Expired": "Expired",
    "Draft": "Draft",
    "RequiresApproval": "RequiresApproval",
} as const;

export type RateGroupStatus = keyof typeof RateGroupStatus;

export const RateType = {
    "Yield": "Yield",
    "IpsNetRate": "IpsNetRate",
    "Per1000DifferenceMinForIps": "Per1000DifferenceMinForIps",
    "DealerNetRate": "DealerNetRate",
    "GrossSalesRate": "GrossSalesRate",
    "IpsYieldAtDealerNetRate": "IpsYieldAtDealerNetRate",
} as const;

export type RateType = keyof typeof RateType;

export const SPVStatus = {
    "Dormant": "Dormant",
    "Live": "Live",
    "NoNewDeals": "NoNewDeals",
    "Dead": "Dead",
} as const;

export type SPVStatus = keyof typeof SPVStatus;

export const ScheduleStatus = {
    "Inactive": "Inactive",
    "Active": "Active",
} as const;

export type ScheduleStatus = keyof typeof ScheduleStatus;

export const ServiceStatus = {
    "None": "None",
    "Available": "Available",
    "Unavailable": "Unavailable",
} as const;

export type ServiceStatus = keyof typeof ServiceStatus;

export const ServiceType = {
    "Mandatory": "Mandatory",
    "Discretionary": "Discretionary",
    "Default": "Default",
} as const;

export type ServiceType = keyof typeof ServiceType;

export const SettingsUploadEntityType = {
    "QuarterlyServices": "QuarterlyServices",
    "MeteredServices": "MeteredServices",
    "Paper": "Paper",
    "LfpPaper": "LfpPaper",
    "LfpProductsAndServices": "LfpProductsAndServices",
} as const;

export type SettingsUploadEntityType = keyof typeof SettingsUploadEntityType;

export const SheetType = {
    "NewMaster": "NewMaster",
    "Rewrite": "Rewrite",
    "ScheduleToTheMaster": "ScheduleToTheMaster",
    "RewriteNewMasterDocument": "RewriteNewMasterDocument",
} as const;

export type SheetType = keyof typeof SheetType;

export const SortDirection = {
    "Asc": "Asc",
    "Desc": "Desc",
} as const;

export type SortDirection = keyof typeof SortDirection;

export const SystemConfigType = {
    "Docusign": "Docusign",
    "Maintenance": "Maintenance",
} as const;

export type SystemConfigType = keyof typeof SystemConfigType;

export const UserArea = {
    "All": "All",
    "AccountManager": "AccountManager",
    "IpsAdmin": "IpsAdmin",
    "Funder": "Funder",
    "SupplierAdmin": "SupplierAdmin",
    "IpsSuperUser": "IpsSuperUser",
    "SalesAdmin": "SalesAdmin",
    "SalesManager": "SalesManager",
} as const;

export type UserArea = keyof typeof UserArea;

export const UserSortField = {
    "Name": "Name",
    "Email": "Email",
    "UserStatusText": "UserStatusText",
    "UserTypeText": "UserTypeText",
    "Company": "Company",
} as const;

export type UserSortField = keyof typeof UserSortField;

export const UserStatus = {
    "Verified": "Verified",
    "NotVerified": "NotVerified",
    "Disabled": "Disabled",
} as const;

export type UserStatus = keyof typeof UserStatus;

export const UserType = {
    "HQ": "HQ",
    "Dealer": "Dealer",
} as const;

export type UserType = keyof typeof UserType;

export const WeightUnit = {
    "None": "None",
    "GSM": "GSM",
    "MIC": "MIC",
    "LB": "LB",
} as const;

export type WeightUnit = keyof typeof WeightUnit;
